(function($){

    $('body').on('click', '.event-short', function(e){
        e.preventDefault();
        $(this).next('.event-popup').fadeIn(500);
    })
    $('body').on('click', '.event-popup .close', function(e){
        e.preventDefault();
        $(this).closest('.event-popup').fadeOut(500);
    })
    $('body').on('click', '.ag-calendar .calendar-prev, .ag-calendar .calendar-next', function(e){
        e.preventDefault();
        var intrf = $(this).closest('.ag-calendar').find('[name="calendar-view"]').val();
        var year = $(this).data('year');
        var month = $(this).data('month');
        var calendar = $(this).closest('.ag-calendar').attr('id');
        load_ag_calendar(year, month, intrf, calendar);
    })
    $('body').on('click', '.ag-calendar .interface .view a', function(e){
        e.preventDefault();
        $(this).closest('.ag-calendar').find('[name="calendar-view"]').val($(this).attr('data-value')).trigger('change');
    })
    $('body').on('change', '.ag-calendar [name="calendar-view"]', function(){
        var intrf = $(this).val();
        var year = $(this).closest('.ag-calendar').attr('data-year');
        var month = $(this).closest('.ag-calendar').attr('data-month');
        var calendar = $(this).closest('.ag-calendar').attr('id');
        load_ag_calendar(year, month, intrf, calendar);
    })

    $(document).ready(function(){
        if($('.ag-calendar').length > 0){
            $('.ag-calendar').each(function(){
                if($(this).find('.ag-calendar-table').length > 0){
                    // $(this).find('.month').width($(this).find('.ag-calendar-table').width() - 20);
                }
            })
        }

        if($('.agw-even-date').length > 0){
            $('.agw-even-date').each(function(){
                $(this).appendTo($(this).closest('.elementor-post__card').find('.elementor-post__thumbnail__link'));
                $(this).fadeIn(500);
            })
        }
    })

    function load_ag_calendar(year, month, intrf, calendar) {
        var height = 0;
        var c = $('#' + calendar);
        $.ajax({
            url: ajax_obj.ajaxurl,
            method: 'post',
            data: {
                'action': 'load_ag_calendar',
                'year': year,
                'month': month,
                'interface': intrf,
                'nonce': ajax_obj.nonce
            },
            beforeSend: function beforeSend(errorThrown) {
                c.css('height', c.height());
                c.addClass('loading');
                c.html('<div class="loader"><img src="'+c.data('loader')+'" /></div>');
                c.attr('data-year', year);
                c.attr('data-month', month);
            },
            success: function success(data) {
                c.removeClass('loading');
                c.removeAttr('style');
                c.html(data);
                if(c.find('.ag-calendar-table').length > 0){
                    // c.find('.month').width(c.find('.ag-calendar-table').width() - 20);
                }
            },
            error: function error(errorThrown) {
                console.log(errorThrown);
            }
        });
    }

})(jQuery)